import { FC, useState } from 'react'
import { RenderIf } from 'components/RenderIf'
import { Button } from 'featureSliced/entities/Button'
import { CheckBox } from 'featureSliced/entities/CheckBox'
import { CCProvider } from 'featureSliced/shared/utils/getCCProviderIcon'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { Radio, RadioContainer } from 'components/Radio/styled'

type CardsModalProps = {
  closeModal: () => void
  handlePayment: (
    useNewCard: boolean,
    updateActiveCard: boolean,
    useLoyaltyCard: boolean
  ) => void
  cardsData: {
    isLoyaltyCardExisting: boolean
    isLoyaltyCardDisabled: boolean
    userCardData: any
  }
}

// '0' ==> useLoyaltyCard
// '1' ==> useSavedCard
// '2' ==> useNewCard

export const CC_CardsModal: FC<CardsModalProps> = ({
  handlePayment,
  closeModal,
  cardsData,
}) => {
  const t = useTranslations()
  const { isLoyaltyCardExisting, isLoyaltyCardDisabled, userCardData } =
    cardsData

  const [updateActiveCard, setUpdateActiveCard] = useState(false)
  const [value, setValue] = useState<'0' | '1' | '2'>('1')

  const changeValue = (e: any) => {
    if (e.target.value !== '2') {
      setUpdateActiveCard(false)
    }
    setValue(e.target.value)
  }

  const handlePayClick = () => {
    handlePayment(value === '2', updateActiveCard, value === '0')
    closeModal()
  }

  return (
    <div>
      <RenderIf condition={isLoyaltyCardExisting}>
        <RadioContainer isDisabled={isLoyaltyCardDisabled}>
          <Radio
            type="radio"
            id="customer"
            name="customerCard"
            value={0}
            checked={value === '0'}
            onChange={changeValue}
            disabled={isLoyaltyCardDisabled}
          />
          <label htmlFor="customer">
            {isLoyaltyCardDisabled
              ? `${t('order.useCustomerCard')} (${t(
                  'common.insufficientFunds'
                )})`
              : t('order.useCustomerCard')}
          </label>
        </RadioContainer>
      </RenderIf>

      {/* <RenderIf condition={userCardData && paymentProvider !== 3}> */}
      <RenderIf condition={userCardData}>
        <RadioContainer>
          <Radio
            type="radio"
            id="saved"
            name="card"
            value={1}
            checked={value === '1'}
            onChange={changeValue}
          />
          <label htmlFor="saved">
            <CCProvider
              cardMask={JSON.parse(userCardData || null)?.masked}
              brandName={JSON.parse(userCardData || null)?.brand?.PaymentMethod}
            />{' '}
            {JSON.parse(userCardData || null)?.masked}
          </label>
        </RadioContainer>
      </RenderIf>

      <RadioContainer>
        <Radio
          type="radio"
          id="useNew"
          name="card"
          value={2}
          checked={value === '2'}
          onChange={changeValue}
        />
        <label htmlFor="useNew">{t('selfService.useNewCard')}</label>
      </RadioContainer>

      <RenderIf condition={value === '2'}>
        <CheckBox
          isChecked={updateActiveCard}
          onClick={setUpdateActiveCard}
          label={t('selfService.newCardAsDefault')}
          isDisabled={value !== '2'}
        />
      </RenderIf>

      <RenderIf condition={value !== '2'}>
        <div style={{ height: '28px' }} />
      </RenderIf>

      <br />

      <Button buttonType="common" width="100%" onClick={handlePayClick}>
        {t('cover.pay')}
      </Button>
    </div>
  )
}
